import React from 'react';
import { StyledChildIcon, StyledItem, StyledOption, StyledOptionIcon } from '../../../common/ui/styled';
export var IconOptionLabel = function IconOptionLabel(_ref) {
  var option = _ref.option;
  return /*#__PURE__*/React.createElement(StyledOption, null, /*#__PURE__*/React.createElement(StyledItem, null, option.icon !== undefined && /*#__PURE__*/React.createElement(StyledOptionIcon, {
    src: option.icon,
    alt: option.label
  }), /*#__PURE__*/React.createElement(StyledChildIcon, null, option.label)));
};